<template>
    <div class="app-container" style="margin-top: -50px">
        <div style="margin-left:30px;margin-right:30px">
            <p>选择角色</p>
            <p style="line-height:2em;color: gray"><i class="el-icon-warning-outline" style="color: red"></i>若此处找不到所需的资源访问角色，请联系系统管理员。 <el-button type="primary" style="float: right;border-radius: 0px"  size="medium" @click="openAddUserRoleDialog()">新增产品资料访问角色</el-button></p>
            <el-table
                    :data="csRoleList"
                    style="width: 100%;overflow: auto;"
                    max-height="450px"
                    highlight-current-row
                    @row-click="rowClick">
                <el-table-column
                        prop="roleName"
                        align="center"
                        label="资料访问角色">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" :width="300" placement="left">
                            <p >角色权限: {{ getPriority(scope.row.priorityInCs) }}</p>
                            <div slot="reference" class="name-wrapper">
                                {{ scope.row.roleName }}
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="address"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-delete" style="color: red" type="text" :disabled="getDisabledJudge(scope.row)" @click="deleteUserRole(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="margin-left:30px;margin-right:30px;margin-top: 20px">
            <p>设置资料访问权限</p>
            <p style="line-height:2em;color: gray" ><i class="el-icon-warning-outline" style="color: red"></i>不同的角色针对不同的资料类型有不同的访问权限。在<a style="color: blue">上表选定角色</a>后，在此处为角色分配各种资料类型的访问权限。</p>
            <p>当前角色：<b>{{chooseRoleName!==""?chooseRoleName:"无"}}</b><el-button type="primary" style="float: right;border-radius: 0px" size="medium" @click="openAddFileCategoryDialog()">新增资料类型</el-button></p>
            <el-table
                    :data="fileCategoryList"
                    style="width: 100%;overflow: auto;"
                    max-height="450px">
                <el-table-column
                        align="center"
                        label="资料类型">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="left">
                            <p>资料类型描述: {{ scope.row.typeDesc }}</p>
                            <div slot="reference" class="name-wrapper">
                                <el-tag size="medium">{{ scope.row.typeName }}</el-tag>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="read"
                        align="center"
                        label="浏览">
                    <template slot-scope="scope">
                      <el-checkbox  v-model="scope.row.read" :disabled="flagPriority" ></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="download"
                        align="center"
                        label="下载"
                >
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.download" :disabled="flagPriority" @change="changeDownloadAccess(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" style="color: darkgreen" @click="openEditFileCategoryDialog(scope.row)">编辑</el-button>
                        <el-button icon="el-icon-delete" style="color: red" type="text"  @click="deleteCsFileType(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div align="center" style="margin-top: 10px">
            <el-button size="medium" style="border-radius: 0px" @click="resetAccess()" :disabled="flagPriority">
                撤 销
            </el-button>
            <el-button type="primary" size="medium" style="border-radius: 0px" @click="saveAccess()" :disabled="flagPriority">
                保 存
            </el-button>
        </div>

        <!-- 添加角色 -->
        <el-dialog title="添加资料访问角色" :modal="false" :visible.sync="addUserRoleDialog" width="30%">
            <el-form >
                        <el-form-item
                                label="系统角色名称"
                                :label-width="labelWidth">
                            <el-select
                                    v-model="addCsFileRoleForm.roleID"
                                    clearable
                                    style="width:300px"
                            >
                                <el-option
                                        v-for="item in systemRoleList"
                                        :key="item.roleID"
                                        :label="item.roleName"
                                        :value="item.roleID"
                                        :disabled="getDisabledRole(item.roleID)"></el-option>
                            </el-select>

                        </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="addUserRoleDialog = false">
                    取消
                </el-button>
                <el-button type="primary" size="small" @click="addUserRole()">
                    确认
                </el-button>
            </div>
        </el-dialog>

        <!-- 添加类别 -->
        <el-dialog
                title="新增资料类型"
                :visible.sync="addFileCategoryDialog"
                :modal="false"
                width="40%"
        >
            <el-form :model="addFileCategoryForm">
                <el-form-item label="资料类型名称" :label-width="labelWidth" required>
                    <el-input v-model="addFileCategoryForm.name"></el-input>
                </el-form-item>
                <el-form-item label="资料类型描述" :label-width="labelWidth">
                    <el-input
                            type="textarea"
                            rows="2"
                            v-model="addFileCategoryForm.desc"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="addFileCategoryDialog = false">取消</el-button>
                <el-button type="primary" size="small" @click="addFileCategory()">确认</el-button>
            </div>
        </el-dialog>


        <!-- 编辑产品类型对话框 -->
        <el-dialog title="编辑产品类型及角色使用权限" :modal="false" :visible.sync="editFileCategoryDialog" width="35%">
            <el-form :model="editFileCategoryForm">
                <el-form-item label="类型名称" :label-width="labelWidth" required>
                    <el-input v-model="editFileCategoryForm.typeName"></el-input>
                </el-form-item>
                <el-form-item label="描述" :label-width="labelWidth">
                    <el-input type="textarea" rows="2" v-model="editFileCategoryForm.typeDesc"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="editFileCategoryDialog = false">
                    取消
                </el-button>
                <el-button type="primary" size="small" @click="editFileCategory()">
                    确认
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    getCsRoleList,       // 获取产品访问角色 （产品访问角色从系统中选取）
    getFileCategoryList,
    csFileRoleUpdate,    // 根据角色id和资料类型列表更新权限
    addFileCategory,
    editFileCategory,
    deleteFileCategory,
} from "@/api/system/CSDocument/file";
import {
    getSystemRoleList,
    setCSRole,

} from "@/api/system/CSDocument/user";

export default{
    data() {
        return {
            flagPriority:false,
            labelWidth: "135px",
            priorityInCs:[
                // {value:-1,desc:"禁止访问任何文件"},
                {value:0,desc:"可访问普通用户能访问的文件"},
                {value:1,desc:"1.可访问“资料类型”中为此角色配置权限的文件，且文件适用的设备必须是用户所绑定的；\n2.可访问普通用户能访问的文件"},
                {value:2,desc:"1.可访问“资料类型”中为此角色配置权限的文件；\n2.可访问普通用户能访问的文件"},
                {value:3,desc:"可访问所有的文件"}
            ],
            csRoleList:[],
            fileCategoryList:[],
            drawerEditFileCategory:false,
            currentRowId:"",//选中某个角色
            chooseRoleName:"",//当前选中角色名称
            updateCsFileTypeForm:{roleId:'',bindTypeDataList:[]}, //csFileTypeID permissionType
            addCsFileRoleForm:{roleID:'',priorityCs:''},
            addUserRoleDialog:false,
            addFileCategoryDialog:false,
            systemRoleList:[],       //系统角色列表
            addFileCategoryForm: {name:"",desc:"",roleList:[]}, // 添加资料类型对话框开关
            editFileCategoryDialog: false,  // 编辑文件类别对话框开关（默认关闭）
            editFileCategoryForm: {},       // 编辑文件类别对话框开关
        }
    },
    created() {
        this.currentRowId="";
        this.chooseRoleName="";
        this.getCsRoleList();
        this.getAllFileCategoryList();
    },
    methods: {

        editFileCategory() {
            // 表单验证
            if (!this.editFileCategoryForm.typeName) {
                this.$message({
                    message: "类别名称不能为空",
                    type: "warning",
                });
                return;
            }
            const data = {
                csFileTypeID: this.editFileCategoryForm.csFileTypeID,
                typeName: this.editFileCategoryForm.typeName,
                typeDesc: this.editFileCategoryForm.typeDesc,
            };
            editFileCategory(data).then(() => {
                this.$message({
                    message: "修改成功",
                    type: "success",
                });
                this.editFileCategoryDialog = false;
                this.getAllFileCategoryList();
            });
        },

        openEditFileCategoryDialog(row) {
            // 初始化
            this.editFileCategoryForm = {};
            this.editFileCategoryForm = row;

            this.editFileCategoryDialog = true;
        },

        getDisabledRole(id){
            if(this.csRoleList!==[]){
                for(const temp of this.csRoleList){
                    if(temp.roleID === id){
                        return true;
                    }
                    else{
                        continue;
                    }
                }
            }
            return false;
        },
        getDisabledJudge(row){
            if(row.sysDefault ===1){
                return true;
            }
            else{
                return false;
            }
        },

        changeDownloadAccess(row) {
            if (true === row.download) {
                row.read = true;
            }
        },

        deleteCsFileType(row){
            let params = {
                csFileTypeID: row.csFileTypeID,
            };
            this.$confirm("您要删除此资料类型吗？", this.$t("tips"), {
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("no"),
                type: "warning",
            })
                .then(() => {
                    deleteFileCategory(params).then(() => {
                        this.$notify({
                            title: '操作成功',
                            type: 'success'
                        });
                        this.getAllFileCategoryList();
                    });
                })
        },
        /**
         * 打开新增资料类型对话框
         */
        openAddFileCategoryDialog(){
            // 初始化
            this.addFileCategoryForm.name="";
            this.addFileCategoryForm.desc="";
            this.addFileCategoryForm.roleList=[];
            this.addFileCategoryDialog = true;
        },
        /**
         * 新增资料类型
         */
        addFileCategory(){
            if (!this.addFileCategoryForm.name) {
                this.$notify.error({
                    title: '错误',
                    message: '类别名称不能为空!'
                });
                return;
            }
            const roleList=[];
            if(this.csRoleList!==[]){
                for(const temp of this.csRoleList){
                    roleList.push({csFileRoleID:temp.roleID,permissionType:0});
                }
            }
            const data = {
                typeName: this.addFileCategoryForm.name,
                typeDesc: this.addFileCategoryForm.desc,
                userDataType: 2,
                roleList: roleList,
            };
            addFileCategory(data).then(() => {
                this.$notify({
                    title: '操作成功',
                    type: 'success'
                });
                this.addFileCategoryDialog = false;
                this.getAllFileCategoryList();
            });
        },

        /**
         * 新增客服文档角色
         */
        addUserRole(){
            console.log(this.addCsFileRoleForm);
            if (!this.addCsFileRoleForm.roleID) {
                this.$notify.error({
                    title: '错误',
                    message: '系统角色名称不能为空!'
                });
                return;
            }
            if(this.csRoleList!=null){
                for(const temp of this.csRoleList){
                    if(temp.roleID===this.addCsFileRoleForm.roleID){
                        this.$notify.error({
                            title: '错误',
                            message: '产品资料角色已存在，请重新选择系统角色!'
                        });
                        return;
                    }
                }
            }
            if (this.addCsFileRoleForm.priorityCs===null) {
                this.$notify.error({
                    title: '错误',
                    message: '文档访问权限不能为空!'
                });
                return;
            }
            const data = {
                roleList:[
                    {roleId: this.addCsFileRoleForm.roleID}],
                workInCs:1
            };
            setCSRole(data).then(() => {
                this.$notify({
                    title: '操作成功',
                    type: 'success'
                });
                this.addUserRoleDialog = false;
                this.getCsRoleList();
            });
        },
        /**
         * 打开添加用户角色对话框
         */
        openAddUserRoleDialog() {
            // 初始化
            this.addCsFileRoleForm.roleID='';
            this.addCsFileRoleForm.priorityCs='';

            this.getSystemRoleList().then((res) => {
                this.addUserRoleDialog = true;
            });
        },

        /**
         * 获取系统角色列表
         */
        getSystemRoleList(){
            return new Promise((resolve, reject) => {
                let params = {
                    orderType: "",
                    orderBy: "",
                    pageNumber: this.currentPage,
                    pageSize: 100,
                };
                getSystemRoleList(params).then((res)=>{
                    if(res.data.result!==null){
                        this.systemRoleList=[];
                        for(const temp of res.data.result){
                            if(temp.roleID!==1){
                                this.systemRoleList.push(temp);
                            }
                        }
                    }
                    resolve("getSystemRoleList done");
                })
            });

        },

        /**
         * 重置当前角色下的产品资料权限
         */
        resetAccess(){
            if(this.currentRowId!==""){
                this.rowClick({roleID:this.currentRowId,roleName:this.chooseRoleName});
            }
        },
        /**
         * 点击某角色，展示对应产品资料的访问权限
         */
        rowClick(row){
            console.log(row);
            this.currentRowId = row.roleID; //选中角色id
            this.chooseRoleName=row.roleName;//选中角色名字
            if(row.priorityInCs!==null && row.priorityInCs===3){
                this.flagPriority=true;
                this.chooseRoleName+="（系统不提供在此角色下编辑资料类型权限操作）"
            }
            else{
                this.flagPriority=false;
            }
            for (const temp of this.fileCategoryList) {
                temp.read = false;
                temp.download = false;
                if (temp.roleList !== null) {
                    for (const role of temp.roleList) {
                        //0 为不可读 不可下载
                        if (role.roleID === this.currentRowId) {
                            if (1 === role.permissionType) {
                                temp.read = true;
                                temp.download=false;
                            } else if (2 === role.permissionType) {
                                temp.download = true;
                                temp.read = true;
                            } else {
                                temp.read = false;
                                temp.download = false;
                            }
                            break;
                        }
                    }
                }
            }
        },

        saveAccess(){
            if (this.currentRowId !== "" && this.fileCategoryList !== []) {
                this.updateCsFileTypeForm.roleId=this.currentRowId;
                this.updateCsFileTypeForm.bindTypeDataList=[];
                for(const temp of this.fileCategoryList){
                    const typeData={csFileTypeID:temp.csFileTypeID, permissionType:''};
                    if(temp.read===true){
                        if(temp.download===true){
                            typeData.permissionType=2;
                        }
                        else{
                            typeData.permissionType=1;
                        }
                    }
                    else{
                        if(temp.download===true){
                            this.$notify.error({
                                title: '错误',
                                message: '系统不支持：“不可浏览、可下载”配置，请重新配置\"'+temp.typeName+'\"的权限'
                            });
                            return;
                        }
                        typeData.permissionType=0;
                    }
                    this.updateCsFileTypeForm.bindTypeDataList.push(typeData);
                }
                csFileRoleUpdate(this.updateCsFileTypeForm).then((res)=>{
                    if(res.code===200){
                        this.$notify({
                            title: '操作成功',
                            type: 'success'
                        });
                        this.getAllFileCategoryList();
                    }
                })

            }
            else{
                if(this.currentRowId===""){
                    this.$notify({
                        title: '温馨提示',
                        message: '请先选择角色，再对角色进行资料类型访问权限配置',
                        type: 'warning'
                    });
                }
            }
        },
        deleteUserRole(row){
            const params = {
                roleList:[
                    {roleId: row.roleID}],
                workInCs:0
            };
            this.$confirm("您确定要删除此客服文档角色吗？", this.$t("tips"), {
                confirmButtonText: this.$t("yes"),
                cancelButtonText: this.$t("no"),
                type: "warning",
            })
                .then(() => {
                    setCSRole(params).then(() => {
                        this.$notify({
                            title: '操作成功',
                            message: '已删除该资料访问角色',
                            type: 'success'
                        });
                        this.getCsRoleList();
                    });
                })
        },


        /**
         * 获取资料类型列表
         */
        getAllFileCategoryList() {
            this.currentRowId="";
            this.chooseRoleName="";
            let params = {
                sortName: "",
                sortOrder: "asc",
                pageNumber: 1,
                pageSize: 99,
                keyword: "",
                where: "",
            };
            getFileCategoryList(params).then((res) => {
                this.fileCategoryList=[];
                for(const temp of res.data.rows){
                    if (temp.deleteTime === null){
                        temp.read=false;
                        temp.download=false;
                        this.fileCategoryList.push(temp);
                    }
                }
            });
        },

        /**
         * 获取客服文档角色信息
         */
        getCsRoleList(){
            this.currentRowId="";
            this.chooseRoleName="";
            let param={
                orderType: "",
                orderBy: "",
                pageNo:1,
                pageSize:100,
            };
            getCsRoleList(param).then((res)=>{
                this.csRoleList=res.data.result;
            });
        },

        /**
         * 获取角色权限
         */
        getPriority(value){
            if(value !=null){
                for (const temp of this.priorityInCs){
                    if(temp.value===value){
                        return temp.desc;
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>